module.exports = __webpack_public_path__ + "static/media/ui_def-no.5202aafc.svg";